import React from "react";
import ActionButtons from "../../../components/ui/popups/ActionButtons";
import { ShareableOrg } from "../../../services/orgSharing";
import { shareStatusOf } from "./useOrgSharing";

// Confirm popup for withdrawing a still-PENDING share request (ACDPA-186) — "Sent request" in the
// share directory and "Cancel request" on "Who can see my data" both open it; both hit DELETE
// .../share, the only route that can withdraw a request.
// ⛔ F-492 (UAT, URS_6.8): nothing opens its accepted-row "Revoke Access" copy any more. Leaving an
// organization is the X on "Who can see my data" and its Leave dialog (`OrgRemoveConfirm`); the
// branch stays only so a stale list that reports an accepted row here still reads truthfully.
type Props = {
  org: ShareableOrg | null;
  /** "Parent · Location" (or the org's own name) — computed by the caller via orgDisplayName. */
  displayName: string;
  onConfirm: (org: ShareableOrg) => void | Promise<void>;
  onCancel: () => void;
};

const UnshareOrgConfirm: React.FC<Props> = ({ org, displayName, onConfirm, onCancel }) => {
  const isPending = org ? shareStatusOf(org) === "pending" : false;
  return (
    <ActionButtons
      isOpen={!!org}
      onClose={onCancel}
      title={isPending ? "Cancel request?" : "Revoke Access"}
      message={
        !org
          ? ""
          : isPending
            ? `Withdraw your pending request to ${displayName}? You can request again later.`
            : `${displayName} will no longer have access to view your data.`
      }
      actionButtons={[
        {
          text: isPending ? "Cancel request" : "Revoke",
          isPrimary: true,
          action: async () => {
            if (org) await onConfirm(org);
          },
        },
        { text: isPending ? "Keep waiting" : "Cancel", action: onCancel },
      ]}
    />
  );
};

export default UnshareOrgConfirm;
